import { Box, Button, Typography } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import { useAppDispatch, useAppSelector } from '../../assets/hooks';
import { setPopup } from '../../store/slices/popupSlice';

const ConfusedCard = ({ isSmall = false, isCentered = false, buttonText = "Talk to expert" }: { isSmall?: boolean, isCentered?: boolean, buttonText?: string }) => {
    const dispatch = useAppDispatch();
    const currentPopup = useAppSelector((state) => state.popup);
    return (
        <Box
            sx={{
                width: "100%",
                maxWidth: isSmall ? 800 : 1800,
                mx: "auto",
                my: isSmall ? 2 : 3,
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "40px",
                    background: "#70A6B2",
                    position: "relative",
                    px: isSmall ? { xs: 2, sm: 4 } : { xs: 3, sm: 6 },
                    py: isSmall ? { xs: 2, sm: 3 } : { xs: 3, sm: 4 },
                    minHeight: isSmall ? 60 : 90,
                    textAlign: "center",
                }}
            >
                {/* Left circle cutout */}
                <Box
                    sx={{
                        position: "absolute",
                        left: -20,
                        top: "50%",
                        transform: "translateY(-50%)",
                        width: 40,
                        height: 40,
                        borderRadius: "50%",
                        background: "white",
                        zIndex: 1,
                    }}
                />

                {/* Right circle cutout */}
                <Box
                    sx={{
                        position: "absolute",
                        right: -20,
                        top: "50%",
                        transform: "translateY(-50%)",
                        width: 40,
                        height: 40,
                        borderRadius: "50%",
                        background: "white",
                        zIndex: 1,
                    }}
                />

                {/* Content Section */}
                <Box sx={{ 
                    display: "flex", 
                    flexDirection: "column",
                    alignItems: "center", 
                    justifyContent: "center",
                    zIndex: 2,
                    width: "100%",
                    gap: { xs: 2, md: 3 }
                }}>
                    {/* Text Section */}
                    <Box sx={{ 
                        display: "flex", 
                        flexDirection: "column", 
                        alignItems: "center",
                        textAlign: "center"
                    }}>
                        {/* Question Text */}
                        <Typography
                            color="white"
                            fontSize={isSmall ? "2rem" : "2.5rem"}
                            fontWeight="500"
                            sx={{ mb: isSmall ? 1 : 0 }}
                        >
                            Confused?
                        </Typography>
                        
                        {/* Description Text */}
                        <Typography
                            color="rgba(255, 255, 255, 0.9)"
                            sx={{
                                fontSize: isSmall ? { xs: "0.9rem", md: "1rem" } : { xs: "1rem", md: "1.5rem" },
                                maxWidth: isSmall ? "600px" : "1000px",
                                // lineHeight: 1.4
                            }}
                        >
                            Let us simplify it for you, talk to one of our experts now for free!
                        </Typography>
                    </Box>

                    {/* Button Section */}
                    <Box sx={{ 
                        display: "flex", 
                        alignItems: "center",
                        justifyContent: "center"
                    }}>
                        <Button
                            data-no-close="true"
                            sx={{
                                fontSize: isSmall ? '12px' : '14px',
                                height: isSmall ? '36px' : '44px',
                                minWidth: isSmall ? "140px" : "160px",
                                borderRadius: "25px",
                                background: "#fff",
                                color: "#495052",
                                border: "2px solid #F48438",
                                fontWeight: 600,
                                boxShadow: "none",
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                textTransform: "none",
                                '&:hover': {
                                    background: '#F48438',
                                    color: "#FFF"
                                },
                            }}
                            onClick={(e) => {
                                // Prevent clicks from bubbling to any parent ClickAway/Dialog handlers
                                e.stopPropagation();
                                e.preventDefault();
                                
                                // Store the current course popup data before opening callback
                                if (currentPopup.data && currentPopup.data.show) {
                                    localStorage.setItem('coursePopupData', JSON.stringify(currentPopup.data));
                                }
                                
                                // Open callback popup
                                dispatch(
                                    setPopup({
                                        show: true,
                                        data: {
                                            container: {
                                                name: "callback",
                                                dimensions: {
                                                    width: "500px",
                                                    height: { xs: "auto", md: "420px", lg: "410px" } as any,
                                                },
                                            },
                                            type: "custom",
                                        },
                                    })
                                );
                            }}
                        >
                            {buttonText}
                            <PhoneIcon sx={{ fontSize: isSmall ? 14 : 16 }} />
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default ConfusedCard;